import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core'
import { WorkOrder } from '../work-order'
import { DeliveryService } from '../../delivery/delivery.service'
import { BehaviorSubject } from 'rxjs'
import { Delivery } from '../../delivery/delivery'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { FormsModule } from '@angular/forms'
import { ElderQuantityInputControlComponent } from '@elderbyte/ngx-starter'
import { MatInput } from '@angular/material/input'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-work-order-delivery',
  templateUrl: './work-order-delivery.component.html',
  styleUrls: ['./work-order-delivery.component.scss'],
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    ElderQuantityInputControlComponent,
    FormsModule,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class WorkOrderDeliveryComponent {
  private deliveryService = inject(DeliveryService)

  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private _workOrder: WorkOrder

  public delivery$ = new BehaviorSubject<Delivery>(null)

  @Input()
  public set workOrder(workOrder: WorkOrder) {
    this._workOrder = workOrder
    if (workOrder.dispatch?.deliveryId) {
      this.deliveryService
        .findById(workOrder.dispatch.deliveryId)
        .subscribe((delivery) => (this.delivery = delivery))
    } else {
      this.delivery = null
    }
  }

  public get workOrder(): WorkOrder {
    return this._workOrder
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public get delivery() {
    return this.delivery$.getValue()
  }

  public set delivery(delivery: Delivery) {
    this.delivery$.next(delivery)
  }
}
